var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DetailsPane',{attrs:{"title":_vm.announcement.title},on:{"close":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"p-4",domProps:{"innerHTML":_vm._s(_vm.announcement.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }